var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 15C30.67 15 15 30.67 15 50V62.5C15 67.47 19.03 71.5 24 71.5H30C32.76 71.5 35 69.26 35 66.5V55C35 52.24 32.76 50 30 50H21.5V50C21.5 34.26 34.26 21.5 50 21.5C65.74 21.5 78.5 34.26 78.5 50V50H70C67.24 50 65 52.24 65 55V66.5C65 69.26 67.24 71.5 70 71.5H76V73.5C76 78.19 72.19 82 67.5 82H55C53.34 82 52 83.34 52 85C52 86.66 53.34 88 55 88H67.5C75.51 88 82 81.51 82 73.5V50C82 30.67 66.33 15 50 15ZM28.5 56.5V65H24C22.62 65 21.5 63.88 21.5 62.5V56.5H28.5ZM78.5 62.5C78.5 63.88 77.38 65 76 65H71.5V56.5H78.5V62.5Z",
    fill: "#98A6AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.9c71a585e2cf13c8c54cb4ee7394f92f.svg";
export { ForwardRef as ReactComponent };